import { Phone, MessageCircle } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";
import { useLang } from "@/lang";

const Contact = () => {
  const { t } = useLang();
  const faq = t.contact?.faq || [];

  return (
    <section id="contact" data-testid="contact-section" className="relative py-20 lg:py-32 bg-surface/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 grid lg:grid-cols-2 gap-14 lg:gap-20">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] font-mono text-amber-700/90 mb-4 flex items-center gap-3">
            <span className="w-8 h-px bg-amber-500/60 inline-block" />
            {t.contact?.eyebrow}
          </p>
          <h2 data-testid="contact-title" className="font-serif text-2xl sm:text-3xl lg:text-5xl tracking-tight text-ivory leading-[1.1]">
            {t.contact?.title}
          </h2>

          <div className="mt-10 flex flex-col gap-4 max-w-md">
            <a
              data-testid="phone-call-btn"
              href="tel:+33651884802"
              className="group flex items-center justify-between bg-surface border border-amber-500/20 hover:border-amber-400/60 rounded-lg px-6 py-5 hover:shadow-[0_0_30px_rgba(212,175,55,0.12)] transition-all duration-300"
            >
              <div className="flex items-center gap-4">
                <span className="w-11 h-11 rounded-full bg-champagne/10 border border-amber-500/30 flex items-center justify-center text-champagne group-hover:bg-champagne group-hover:text-obsidian transition-colors duration-300">
                  <Phone size={17} strokeWidth={1.5} />
                </span>
                <div>
                  <div className="text-[11px] uppercase tracking-[0.2em] text-zinc-500">{t.contact?.phoneLabel}</div>
                  <div className="font-mono text-lg text-ivory mt-0.5">+33 6 51 88 48 02</div>
                </div>
              </div>
            </a>
            <a
              data-testid="whatsapp-btn"
              href="https://wa.me/33651884802"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-between bg-surface border border-amber-500/20 hover:border-amber-400/60 rounded-lg px-6 py-5 hover:shadow-[0_0_30px_rgba(212,175,55,0.12)] transition-all duration-300"
            >
              <div className="flex items-center gap-4">
                <span className="w-11 h-11 rounded-full bg-champagne/10 border border-amber-500/30 flex items-center justify-center text-champagne group-hover:bg-champagne group-hover:text-obsidian transition-colors duration-300">
                  <MessageCircle size={17} strokeWidth={1.5} />
                </span>
                <div>
                  <div className="text-[11px] uppercase tracking-[0.2em] text-zinc-500">{t.contact?.whatsappLabel}</div>
                  <div className="font-mono text-lg text-ivory mt-0.5">+33 6 51 88 48 02</div>
                </div>
              </div>
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <h3 className="font-serif text-xl sm:text-2xl text-ivory mb-6">{t.contact?.faqTitle}</h3>
          <Accordion type="single" collapsible data-testid="faq-accordion" className="w-full">
            {faq.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-amber-500/15">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left text-sm sm:text-base text-zinc-700 hover:text-champagne-bright hover:no-underline py-5 transition-colors">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-zinc-600 pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default Contact;
